import { Action, createReducer, on } from '@ngrx/store';
import * as HelpStoreActions from './help-store.actions';
import { HelpDetail as HelpDetails } from '../models/help-detail';

export const helpStoreFeatureKey = 'helpStore';

export interface State {
    helpDetails?: HelpDetails;
}

export const initialState: State = {};

export const reducer = createReducer(
    initialState,

    on(HelpStoreActions.loadHelpStores, (state) => state),
    on(HelpStoreActions.loadHelpDetailsSuccess, (state, action): State => {
        return {
            ...state,
            helpDetails: action.data,
        };
    })
);
